<template>
  <v-card outlined tile width="100%" height="100%">

    <div class="d-flex justify-center align-center" style="width: 100%; height: 100%" v-if="captchaVisible">
      <v-card width="unset" outlined>
           <v-card-actions class="justify-end">
          <v-btn @click="closeCaptcha" text icon large>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
          <v-divider />
        <v-card-text>
          <recaptcha :sitekey="sitekey" @verify="verifySearch" />
        </v-card-text>
      </v-card>
    </div>

    <div ref="search" v-else class="pa-3">

      <div class="d-flex align-center mb-3">
        <sg-widget-icon class="d-block" />
        <div class="ml-2 text-h6">{{title}}</div>
      </div>

      <v-form ref="form" lazy-validation @submit.stop.prevent>

        <v-text-field ref="account" v-model="account" :rules="accountRules" class="ma-0" label="Лицевой счет"
          placeholder="Введите лицевой счет" autocomplete="off" @keyup.enter="doMagic('account')"
          :error-messages="errors" />

        <v-text-field v-for="wf in widgetFields" :key="wf.name" v-model="fields[wf.name]" :ref="'field-'+wf.name"
          :label="wf.label" :type="wf.type" autocomplete="off" @keyup.enter="doMagic(wf.name)"
          :rules="wf.optional ? mandatoryRules : []" />

      </v-form>

      <div class="d-flex align-end">
        <a href="#" @click.stop.prevent="searchAccount" class="body-2">Узнать лицевой счет</a>
        <v-spacer />
        <v-btn dark depressed color="primary" @click.stop="search('')" :loading="loading">Далее</v-btn>
      </div>


      <div v-if="privacyPolicyUrl" class="grey--text mt-2"
        style="font-size: 10px; width: 270px; word-break: break-word; word-wrap: break-word;">
        Пользуясь данным сервисом Вы соглашаетесь с <a :href="privacyPolicyUrl" target="_blank">Политикой
          конфиденциальности</a>.
      </div>

    </div>

  </v-card>
</template>

<script>
  /*   import CountersTable from './CountersTable' */

  import widgetMixin from '@/mixins/widgetMixin'
  import SgWidgetIcon from '@/components/SgWidgetIcon'
  import Recaptcha from './RecaptchaV2.vue'


  export default {
    name: "sg-widget-search",
    mixins: [widgetMixin],
    components: {
      Recaptcha,
      SgWidgetIcon
    },
    props: {
      initAccount: {
        type: String,
        require: false
      }
    },
    watch: {
      account() {
        this.errors = null
      },
      widgetFields() {
        this.defineFields()
        this.calculateHeight()
      }
    },
    computed: {

      title() {
        if (this.wgType == 'counters') {
          return "Подать показания"
        }
        return "Оплатить услуги"
      },

      wgType() {
        return this.$store.state.options.widgetType
      },

      widgetFields() {
        return this.wgParams.fields || []
      },
      sitekey() {
        return this.wgParams.captchaKey
      },
      method() {
        if (this.wgType == 'counters') {
          return 'searchMeters'
        }
        return 'searchService'
      }
    },
    data() {
      return {

        loading: false,
        captchaVisible: false,

        searchResult: null,
        mandatoryRules: [
          v => !!v || 'Заполните поле'
        ],
        accountRules: [
          v => !!v || 'Укажите лицевой счет'
        ],
        errors: null,


        account: this.initAccount,
        fields: {},

        height: 0
      }
    },
    methods: {

      showError(error) {
        this.errors = error
      },

      doMagic(fieldName) {
        if (this.fields && this.fields.length > 0) {

          if (fieldName == 'account') {

            this.$refs['field-' + this.fields[0].name][0].focus()

          } else {
            let idx = this.fields.findIndex(f => f.name == fieldName)


            if (idx < this.fields.length - 1) {
              this.$refs['field-' + this.fields[idx + 1].name][0].focus()
            } else {

              this.search()
            }
          }
        } else {
          this.search()
        }
      },

      showCaptcha() {
        this.captchaVisible = true
        this.postMessage('dialog:open')
      },

      closeCaptcha() {
        this.captchaVisible = false
        this.postMessage('dialog:close')
      },

      verifySearch(captcha) {
        this.closeCaptcha()
        this.$nextTick(() => {
          this.search(captcha)
        })
      },

      showRecaptcha() {

        this.$eventBus.$emit('modal:open', {

          component: Recaptcha,
          props: {
            sitekey: this.sitekey
          },
          dialogProps: {
            persistent: true,
            noClickAnimation: true,
            fullscreen: true
          },
          listeners: {
            verify: () => {
              this.verifySearch()
            }
          }
        })
      },

      showWidget(searchResult, account, fields) {
        let name = ['payments', 'counters', 'one-form'].includes(this.wgType) ? this.wgType : 'payments'
        this.$router.push({
          name,
          params: {
            searchResult,
            account,
            fields
          }
        })
      },

      searchAccount() {
        this.$router.push({
          name: 'searchAccount'
        })
      },

      search(captchaAnswer) {
        captchaAnswer = captchaAnswer || '';
        if (!this.$refs.form.validate())
          return

        return this.searchWidget(this.account, this.fields, captchaAnswer)
      },

      searchWidget(account, fields, captchaAnswer) {

        this.loading = true

        return this.$api[this.method](this.$store.state.options.providerGuid, account, fields, captchaAnswer)
          .then(searchResult => {
            this.showWidget(searchResult, account, fields)
          })
          .catch(err => {
            console.warn(err)
            switch (err.code) {
              case 10:
              case 11:
              case 99:
                this.showError((err.code == 10 || err.code == 11) ? err.message : "Сервис недоступен. Повторите попытку позже.")
                break;
              case 20:
                this.showCaptcha()
                break;
              case 30:
                /*                 this.$router.push({
                                  name: 'index', params: {reload: true}
                                }) */
                this.$eventBus.$emit('reload')
                break;
              default:
                console.error(`${this.method}: `, err)
                break;
            }
          })
          .finally(() => {
            this.loading = false
          })

      },


      defineFields() {
        this.widgetFields.forEach(wf => {
          this.$set(this.fields, wf.name, wf.value)
        })
      },

      onUpdateSearchProps({
        data: newSearchProps
      }) {
        this.account = newSearchProps.account
        for (let fieldName in this.fields) {
          if (fieldName in newSearchProps) {
            this.fields[fieldName] = newSearchProps[fieldName]
          }
        }
      },

      onWidgetSearch({
        callbacks
      }) {
        let prom = this.search('')
        if (prom) {
          prom.finally(() => {
            callbacks.onComplete && callbacks.onComplete()
          })
        } else {
          callbacks.onComplete && callbacks.onComplete()
        }
      },

      calculateHeight() {
        this.height = this.$refs.search.clientHeight;
        /*     console.log('height: ', this.height) */
      }
    },
    created() {
      this.defineFields()
      this.$eventBus.$on('widget:search', this.onWidgetSearch)
      this.$eventBus.$on('widget:update:search-props', this.onUpdateSearchProps)
      this.postMessage("dialog:close")
    },
    beforeDestroy() {
      this.$eventBus.$off('widget:search', this.onWidgetSearch)
      this.$eventBus.$off('widget:update:search-props', this.onUpdateSearchProps)
    }
  }
</script>

<style scoped>
  .sgb-widget-footer {
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
  }

  /*   .sgb-widget-base {

    display: inline-block;
    background-color: transparent !important;
    margin: 0px !important;

  } */
</style>